import axios from 'axios';
import BaseUrl from '_conf/url';

/**
 * 画像アップロード
 */
//export const uploadImg = formData => axios.$callAPI(() => axios.post(BaseUrl.dataUrl+'images/sm/', { data: formData }));
//export const uploadImg = data => axios.$callAPI(() => axios.post(BaseUrl.dataUrl + 'images/sm/', {data: data}));
export const uploadImg = data =>
    axios.$callAPI(() => {
        return axios.post(BaseUrl.dataUrl + 'image/scale/', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    });
